import { Alert } from '@design-system/components/alert/alert';
import { Button } from '@design-system/components/button/button';
import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { Async } from '@client/new/helpers/types';
import * as styles from './SwitchLookModal.css';

type SwitchLookModalProps = {
  isOpen: boolean;
  themeName: string;
  status: Async<null>;
  onConfirm: () => void;
  onClose: () => void;
};

export const SwitchLookModal = ({
  isOpen,
  themeName,
  status,
  onConfirm,
  onClose,
}: SwitchLookModalProps) => {
  const isSwitching = status.type === 'fetching';

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Switch to the new look?"
      modalClassName={styles.modalWidth}
      disableBackdropClick={isSwitching}
      hideCloseButton={isSwitching}
      testId="switch-look-modal"
    >
      <div className={styles.content}>
        <Typography variant="body" size="large" fontWeight="normal">
          Your channel, program and offer pages switch to the {themeName} theme
          right away.
        </Typography>
        <Typography variant="body" size="large" fontWeight="normal">
          You can&apos;t go back to the old look. You can change the theme any
          time.
        </Typography>
        {status.type === 'fetch-error' ? (
          <Alert
            variant="error"
            title="We couldn't switch your pages"
            details={status.value}
          />
        ) : null}
        <div className={styles.actions}>
          <Button
            variant="text"
            color="neutral"
            onClick={onClose}
            disabled={isSwitching}
          >
            Cancel
          </Button>
          <Button
            color="neutral"
            onClick={onConfirm}
            disabled={isSwitching}
            loading={isSwitching}
          >
            Switch now
          </Button>
        </div>
      </div>
    </Modal>
  );
};
